import Footer from '@/pages/Home/Footer';
import Hero from '@/pages/components/Hero';
import Content from '@/pages/Home/Content';
import { Container, Stack, Typography } from '@mui/material';
import AddressSearch from '@/pages/Home/AddressSearch';
import { useTranslation } from 'react-i18next';

function Home() {
  const { t } = useTranslation('landing-page');

  return (
    <>
      <Hero>
        <Container
          sx={{
            textAlign: 'left',
            width: '100%',
            marginBottom: 'auto'
          }}
        >
          <Stack gap={4}>
            <Typography
              data-cy="hero-title"
              variant="h1"
              color="white"
              fontWeight={900}
              sx={{
                fontFamily: 'Panton, Montserrat, sans-serif',
                fontSize: { xs: '32px', sm: '34px', md: '46px', lg: '58px', xl: '62px' },
                lineHeight: { xs: '1.3', sm: '1.4', lg: '1.2', xl: '1.1' }
              }}
              dangerouslySetInnerHTML={{ __html: t('hero.title') }}
            />
            <AddressSearch />
          </Stack>
        </Container>
      </Hero>
      <Content />
      <Footer />
    </>
  );
}

export default Home;
